import { render, staticRenderFns } from "./order-goods-detail.vue?vue&type=template&id=3cf3bb60&scoped=true"
import script from "./order-goods-detail.vue?vue&type=script&lang=js"
export * from "./order-goods-detail.vue?vue&type=script&lang=js"
import style0 from "./order-goods-detail.vue?vue&type=style&index=0&id=3cf3bb60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf3bb60",
  null
  
)

export default component.exports